eyebrow: "Time & Money Audit"
headline: "How much is manual work<br/><em>actually costing you?</em>"
lead: "Five inputs. Three outputs. See exactly what automation puts back in your team's hands — and your budget."
formTitle: "Tell us about your team"
calculateButton: "Calculate My Savings →"
emptyStateIcon: "⏱️"
emptyStateText: "Fill in your details and hit calculate to see what you could reclaim."
bookCallButton: "Book a Free Audit Call →"
disclaimer: "Estimates based on industry benchmarks. Actual outcomes depend on workflow complexity and implementation scope."

sectors:
  - value: "legal"
    label: "Legal / Compliance"
  - value: "hr"
    label: "HR / Contractor Management"
  - value: "security"
    label: "Security / DevOps"
  - value: "cx"
    label: "Customer Experience / Support"
  - value: "other"
    label: "Other"

tasks:
  - emoji: "📄"
    label: "Document Processing"
    rate: 0.72
  - emoji: "✅"
    label: "Compliance Checking"
    rate: 0.68
  - emoji: "📊"
    label: "Data Entry"
    rate: 0.6
  - emoji: "🧑‍💼"
    label: "Onboarding"
    rate: 0.65
  - emoji: "📋"
    label: "Reporting"
    rate: 0.55
  - emoji: "🔐"
    label: "Security Audits"
    rate: 0.7

sectorRates:
  legal: 0.72
  hr: 0.65
  security: 0.68
  cx: 0.6
  other: 0.55

currency:
  INR:
    symbol: "₹"
    min: 200
    max: 5000
    step: 100
    default: 800
  USD:
    symbol: "$"
    min: 5
    max: 150
    step: 5
    default: 25
